import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Phone, MapPin } from 'lucide-react';
import { useI18n } from '../i18n/LanguageContext';
import { LanguageSwitcher } from './LanguageSwitcher';

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-forest text-sand mt-32" data-testid="site-footer">
      <div className="container-x py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-8">
          <div>
            <div className="kicker !text-rust/90">Gravats Maresme · 1981</div>
            <h3 className="mt-4 font-serif text-3xl md:text-4xl font-light leading-tight text-sand">
              {t.footer.tagline}
            </h3>
          </div>
          <div className="flex flex-col gap-3 text-sand/70 text-sm">
            <a href="mailto:info@gravatsmaresme.com" className="flex items-center gap-3 hover:text-sand transition-colors" data-testid="footer-email">
              <Mail size={14} /> info@gravatsmaresme.com
            </a>
            <a href="tel:+34937532612" className="flex items-center gap-3 hover:text-sand transition-colors" data-testid="footer-phone">
              <Phone size={14} /> +34 93 753 26 12
            </a>
            <div className="flex items-start gap-3">
              <MapPin size={14} className="mt-[3px] flex-shrink-0" />
              <span className="whitespace-pre-line">
                C/ Manuel Ventura Campeny, 8{'\n'}08339 Vilassar de Dalt — Barcelona
              </span>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="kicker !text-sand/45 mb-5">{t.footer.navTitle}</div>
          <ul className="space-y-3 text-sand/80 text-sm">
            <li><Link to="/" className="link-underline" data-testid="footer-nav-home">{t.nav.home}</Link></li>
            <li><Link to="/empresa" className="link-underline" data-testid="footer-nav-about">{t.nav.about}</Link></li>
            <li><Link to="/servicios" className="link-underline" data-testid="footer-nav-services">{t.nav.services}</Link></li>
            <li><Link to="/internacional" className="link-underline" data-testid="footer-nav-international">{t.nav.international}</Link></li>
            <li><Link to="/idi" className="link-underline" data-testid="footer-nav-sustainability">{t.nav.sustainability}</Link></li>
            <li><Link to="/contacto" className="link-underline" data-testid="footer-nav-contact">{t.nav.contact}</Link></li>
            <li><Link to="/brochure" className="link-underline text-rust" data-testid="footer-nav-brochure">Brochure (PDF)</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4 flex flex-col justify-between gap-10">
          <div>
            <div className="kicker !text-sand/45 mb-5">{t.footer.contactTitle}</div>
            <Link
              to="/contacto"
              className="inline-flex items-center gap-3 font-serif text-2xl text-sand hover:text-rust transition-colors"
              data-testid="footer-cta-contact"
            >
              {t.cta.getInTouch} <ArrowUpRight size={20} />
            </Link>
          </div>
          <div>
            <div className="kicker !text-sand/45 mb-3">Language</div>
            <LanguageSwitcher tone="light" />
          </div>
        </div>
      </div>

      <div className="border-t border-sand/15">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] text-sand/55 uppercase tracking-[0.18em]">
          <span>{t.footer.rights.replace('{year}', year)}</span>
          <span className="max-w-xl text-right text-sand/45 normal-case tracking-normal text-[11px]">
            {t.footer.etrade}
          </span>
        </div>
      </div>
    </footer>
  );
}
